import {TABLE_BODY_INFO, TABLE_BODY_INFO2} from "util/tableVariable.js";
import {TABLE_DATA} from "util";
import {renderToString} from "react-dom/server";
import update from "immutability-helper";

const NONE_TEXT = "#AAA";
const BORDER = "1pt solid #000";

const table_render = (type, sheet, external, diffData = {diffAdd: [], diffDel: [], diffUpd: {}}, subd) => {
    const {diffAdd, diffDel, diffUpd} = diffData

    const tbl = sheet[type];
    const header = sheet["header"];
    const so = sheet["sub"];
    const table = document.createElement("table");
    table.classList.add("bpl-table");

    const master = sheet['master'];
    const tblNm = master.projectNm + master.mbrNo;


    
    table.style.border = "none";

    /*
        Header
    */
    table.innerHTML = renderToString(TABLE_DATA?.header?.[type](header, false, null, external, true, false));

    /*
        Body
    */

    const tbody = document.createElement("tbody");

    const SEPERATOR = type === "composition" ? "/" : " ";

    let remarks = [];
    let remarkNum = null;

    let deleted = [];
    let deleted2 = [];

    const TABLE_INFO = external ? TABLE_BODY_INFO[type] : TABLE_BODY_INFO2[type];

    function createTr(d2, type) {
        if (d2.hide !== "TRUE") {
            let tr2 = document.createElement("tr");

            tr2.dataset.uniquecode = d2.uniqueCode;

            let remarkStr = "";
            if (d2.remark && d2.remark !== "FALSE" && d2.remark !== "") {
                let remarkNum = remarks.findIndex(row => d2.remark === row.value)
                if (remarkNum < 0) {
                    remarks.push({
                        value: d2.remark,
                        uniqueCode: [d2.uniqueCode],
                        celNm: "remark",
                    });
                    remarkNum = remarks.length;
                } else {
                    remarks = update(remarks, {
                        [remarkNum]: {
                            $set: {
                                ...remarks[remarkNum],
                                uniqueCode: [...remarks[remarkNum].uniqueCode, d2.uniqueCode]
                            }
                        }
                    })
                    remarkNum = remarkNum + 1;
                }
                remarkStr = "[" + remarkNum + "]";
            }

            let j = 0;
            for (let body_info of TABLE_INFO) {  //createTr
                let td2 = document.createElement("td");

                let chk = body_info.split("+");
                const cellnm = chk?.[1] || chk?.[0];
                td2.dataset.cellnm = cellnm;
                if (chk.length > 1 && !chk[1]?.includes("Cd") && !chk[1]?.includes("Critical")) {
                    td2.innerText = (d2[chk[0]] || "") + SEPERATOR + (d2[chk[1]] || "");
                } else {

                    if (chk[0].includes("Critical") ||
                        chk[0].includes("option")) {  // critical 이나 option 은 index 의 1
                        td2.innerText = d2[chk[1]] || "";
                    } else {
                        td2.innerText = d2[chk[0]] || "";
                    }
                    if(chk[0] === 'sndCritical'){
                        td2.innerText = d2[chk[0]] || ""
                    }
                }
                if (td2.innerText.replaceAll(" ", "").length < 1) {
                    td2.style.backgroundColor = NONE_TEXT;
                }
                if (j < 1) {
                    td2.innerText = `${td2.innerText} ${remarkStr}`;
                    remarkStr = "";
                    j++;
                }
                tr2.appendChild(td2);
            }

            if (type === 'delete') {
                tr2.classList.add("bpl-diff-delete")
            }

            tbody.appendChild(tr2);
        }
    }

    if (type === "composition") {
        let chk = 0;
        for (let d2 of [...tbl]) {
            createTr(d2)
        }

        for (let comDiffDelData of diffDel) {
            createTr(comDiffDelData, 'delete')
        }

    } else {
        for (let d1 in tbl) {
            let remarkVal = so[d1][type + "Remark"];
            if (tbl[d1]?.filter((f) => f.hide !== "TRUE").length < 1 && remarkVal === "FALSE") {
                // if (tbl[d1]?.filter((f) => f.hide !== "TRUE").length < 1) {
                continue;
            }

            let tr1 = document.createElement("tr");

            let td1 = document.createElement("td");
            td1.colSpan = TABLE_INFO.length;

            td1.style.textAlign = "center";
            td1.style.fontWeight = "bold";
            td1.style.padding = "5pt";

            let remarkStr = "";

            if (remarkVal && remarkVal !== "FALSE" && remarkVal !== "") {
                remarkNum = remarks.findIndex(row => remarkVal === row.value)
                if (remarkNum < 0) {
                    remarks.push({
                        value: remarkVal,
                        uniqueCode: [so[d1]?.uniqueCode],
                        celNm: type + "Remark",
                    });
                    remarkNum = remarks.length;
                } else {
                    remarks = update(remarks, {
                        [remarkNum]: {
                            $set: {
                                ...remarks[remarkNum],
                                uniqueCode: [...remarks[remarkNum].uniqueCode, so[d1]?.uniqueCode]
                            }
                        }
                    })
                    remarkNum = remarkNum + 1;
                }
                remarkStr = "[" + remarkNum + "]";
            }


            td1.innerText = `${so[d1]["description"]} ${remarkStr}`;
            td1.dataset.cellnm = "desc";

            tr1.appendChild(td1);
            tr1.dataset.uniquecode = so[d1]?.uniqueCode;
            tbody.appendChild(tr1);

            remarkNum = null;

            let chk = 0;
            for (let d2 of [...tbl[d1]]) {
                createTr(d2);
                chk++;
            } // 삭제된 데이터 를 마지막 행에 각 so에 맞게 추가

            for (let diffDelData of diffDel) {
                
                if (diffDelData.soUniquecode !== so[d1].uniqueCode) {
                    deleted.push(diffDelData.soUniquecode)
                    continue;
                }
                deleted = [...deleted].filter(f => f !== diffDelData.soUniquecode)
                createTr(diffDelData, 'delete');
            }
        }
    }

    deleted = Array.from(new Set(deleted));

    

    for(let a of deleted) {
        let so = subd?.diffDel.find(f => f.uniqueCode === a)
        if(!so) continue;

        let tr1 = document.createElement("tr");

        let td1 = document.createElement("td");
        td1.colSpan = TABLE_INFO.length;

        td1.style.textAlign = "center";
        td1.style.fontWeight = "bold";
        td1.style.padding = "5pt";

        td1.innerText = `${so["description"]}`;
        // td1.innerText = "hllo"
        td1.dataset.cellnm = "desc";

        tr1.appendChild(td1);
        tr1.classList.add("bpl-diff-delete")
        tbody.appendChild(tr1);
        diffDel.filter(f => f.soUniquecode === a).forEach(f => {
            
            createTr(f, 'delete');
        })
    }


    table.appendChild(tbody);
    const figure = document.createElement("figure");
    figure.classList.add("data-table-figure", "table");
    figure.style.width = "100%";
    figure.appendChild(table);

    const pageDiv = document.createElement("div");

    const mainDesc = sheet?.master?.description;

    switch (type.toString().toUpperCase()) {
        case "IN":
            pageDiv.innerHTML = `<h4 class='exclude_heading'>Operational Parameter${mainDesc && " (" + mainDesc + ")"
            }</h4>`;
            break;
        case "OUT":
            pageDiv.innerHTML = `<h4 class='exclude_heading'>Performance Parameter${mainDesc && " (" + mainDesc + ")"
            }</h4>`;
            break;
        case "QC":
            pageDiv.innerHTML = `<h4 class='exclude_heading'>Performance Parameter - QC${mainDesc && " (" + mainDesc + ")"
            }</h4>`;
            break;
        case "COMPOSITION":
            pageDiv.innerHTML = `<h4 class='exclude_heading'>Composition${mainDesc && " (" + mainDesc + ")"
            }</h4>`;
            break;
        default:
            break;
    }

    if (!tbody.innerHTML) {
        const p = document.createElement("p");
        p.style.fontSize = "1.1rem";
        p.innerText = "Not applicable";

        pageDiv.appendChild(p);
    } else {
        const figcaption = document.createElement("figcaption");
        figcaption.dataset.tblnm = tblNm.toUpperCase();
        figcaption.dataset.tbltp = type.toUpperCase();
        figcaption.innerText = pageDiv.querySelector("h4").innerText;
        figure.appendChild(figcaption);

        pageDiv.appendChild(figure);

        if (remarks.length > 0) {
            const ul = document.createElement("ul");
            for (let i in remarks) {
                let li = document.createElement("li");
                li.style.fontSize = "8pt";

                li.innerText = "[" + (parseInt(i) + 1) + "] " + remarks[i].value;
                li.dataset.cellnm = remarks[i].celNm;
                li.dataset.uniquecode = remarks[i].uniqueCode.join(",");
                ul.appendChild(li);
            }
            ul.style.listStyle = "none";
            ul.classList.add("bpl-remark-ul");

            pageDiv.appendChild(ul);
        }
    }

    diffAdd.forEach(i => {
        pageDiv.querySelectorAll(`[data-uniquecode="${i}"]`).forEach(e => {
            e.classList.add(`bpl-diff-add`);
        });
    });

    

    if (diffAdd.length > 0) {
        pageDiv.querySelectorAll(`[data-cellnm="remark"],[data-cellnm="inRemark"],[data-cellnm="outRemark"],[data-cellnm="qcRemark"]`).forEach(diffAdd => {
            // diffAdd.classList.add(`bpl-remark-diff-add`);
            // console.log("diffAdd",diffAdd)
        });
    }

    if (Object.keys(diffUpd).length > 0) {
        pageDiv.querySelectorAll(`[data-cellnm="remark"],[data-cellnm="inRemark"],[data-cellnm="outRemark"],[data-cellnm="qcRemark"]`).forEach(diffUpd => {
            // diffUpd.classList.add(`bpl-remark-diff-add`);
            // console.log("diffUpd",diffUpd)
        });
    }

    try {
        Object.keys(diffUpd).forEach(i => {
            Object.keys(diffUpd[i]).forEach(j => {
                pageDiv.querySelectorAll(`[data-uniquecode="${i}"] [data-cellnm="${j}"]`).forEach(e => {
                    e.style.backgroundColor = "rgb(173, 228, 234)";
                    if(j === "unit1" || j === "unit2") {
                        e.innerHTML = `<span class="bpl-diff-modify">${diffUpd[i]['unit1']+'/'+diffUpd[i]['unit2']}</span> ${e.innerHTML}`
                    } else {
                        e.innerHTML = `<span class="bpl-diff-modify">${diffUpd[i][j]}</span> ${e.innerHTML}`
                    }
                })
            })
        })
    } catch (e) {

    }

    return pageDiv.innerHTML;
};

export default table_render;
